import React from 'react';
import PropTypes from 'prop-types';
import { uniqBy } from 'lodash/fp';

import platformSingleton from '../../../../../../platform/platformSingleton';
import { prop } from '../../../../../../../common/utils/immutableHelper';
import { isPlatformIpad } from '../../../../../../platform/utils/platformDetailsUtils';

import ImageSearchResult from './ImageSearchResult';
import SearchResultsListEmpty from '../../../../../../components/search/results/SearchResultsListEmpty';
import SearchResultsLoading from '../../../../../../components/search/results/SearchResultsLoading';
import ImageSearchResultError from './ImageSearchResultError';
import ImageSearchWebExtensionAlertPanel from './ImageSearchWebExtensionAlertPanel';
import ImageSearchLoadMoreButton from './ImageSearchLoadMoreButton';

import './ImageSearchResultList.scss';

const getPexelsId = prop('pexelsId');
const uniqByPexelsId = uniqBy(getPexelsId);

const ImageSearchResultList = (props) => {
    const { searchResultsList, loading, error, hasMoreResults } = props;

    if (loading && !searchResultsList.length) return <SearchResultsLoading {...props} />;
    if (error) return <ImageSearchResultError error={error} {...props} />;
    if (!searchResultsList.length) return <SearchResultsListEmpty {...props} />;

    const uniqueResults = uniqByPexelsId(searchResultsList);

    return (
        <ul className="ImageSearchResultList">
            {!isPlatformIpad(platformSingleton) && <ImageSearchWebExtensionAlertPanel />}

            {uniqueResults.map((result) => (
                <ImageSearchResult key={getPexelsId(result)} result={result} {...props} />
            ))}

            {hasMoreResults && <ImageSearchLoadMoreButton {...props} />}
        </ul>
    );
};

ImageSearchResultList.propTypes = {
    searchResultsList: PropTypes.array,
    loading: PropTypes.bool,
    hasMoreResults: PropTypes.bool,
    error: PropTypes.string,
};

export default ImageSearchResultList;
